<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre9" id="pgepubid00001">
TABLE OF CONTENTS
</h3>
<h4 class="calibre10 sigil_not_in_toc" id="pgepubid00002">
<a href="#/Text/Section0003">The Descent of Man</a>
<br class="calibre5"/>
<a href="#/Text/Section0004">The Other Two</a>
<br class="calibre5"/>
<span href="#/Text/Section0005" title="Link target outside of Sample">Expiation</span>
<br class="calibre5"/>
<span href="#/Text/Section0006" title="Link target outside of Sample">The Lady's Maid's Bell</span>
<br class="calibre5"/>
<span href="#/Text/Section0007" title="Link target outside of Sample">The Mission of Jane</span>
<br class="calibre5"/>
<span href="#/Text/Section0008" title="Link target outside of Sample">The Reckoning</span>
<br class="calibre5"/>
<span href="#/Text/Section0009" title="Link target outside of Sample">The Letter</span>
<br class="calibre5"/>
<span href="#/Text/Section0010" title="Link target outside of Sample">The Dilettante</span>
<br class="calibre5"/>
<span href="#/Text/Section0011" title="Link target outside of Sample">The Quicksand</span>
<br class="calibre5"/>
<span href="#/Text/Section0012" title="Link target outside of Sample">A Venetian Night's Entertainment</span></h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?42fa1535